webpackJsonp([35783957827783],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constrain = __webpack_require__(28);
	
	var _button = __webpack_require__(25);
	
	var _reactEmotion = __webpack_require__(12);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _vars = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1wquxw0'
	})('box-sizing:border-box;display:grid;grid-template-columns:repeat(', function (props) {
	  return props.columns ? props.columns : 3;
	}, ',1fr);grid-gap:', function (props) {
	  return props.gap ? props.gap : 20;
	}, 'px;position:relative;direction:', function (props) {
	  return props.direction ? props.direction : 'ltr';
	}, ';div{direction:ltr;}@media (max-width:768px){grid-template-columns:repeat(', function (props) {
	  return props.mobile ? props.mobile : 2;
	}, ',1fr);direction:ltr;}');
	
	var HeroStyles = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1wquxw1'
	})('background-color:', _vars.colors.white, ';position:relative;& > div > div{@media (min-width:769px){padding-bottom:0;}}', Grid, '{align-items:center;@media (max-width:425px){grid-gap:20px;margin-bottom:20px;}}img{max-width:100%;height:auto;border-radius:6px;overflow:hidden;}');
	
	var Hero = exports.Hero = function Hero(props) {
	  return _react2.default.createElement(
	    HeroStyles,
	    null,
	    _react2.default.createElement(
	      _constrain.Constrain,
	      null,
	      _react2.default.createElement(
	        Grid,
	        { columns: 2, mobile: 1, direction: "rtl" },
	        _react2.default.createElement(
	          'div',
	          null,
	          props.imageUrl ? _react2.default.createElement(
	            'a',
	            { href: props.imageUrl },
	            _react2.default.createElement('img', { src: props.image, alt: '' })
	          ) : _react2.default.createElement('img', { src: props.image, alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            props.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            props.content
	          ),
	          props.to && _react2.default.createElement(
	            _button.Button,
	            { to: props.to },
	            props.text || 'Learn More'
	          )
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Image = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(12);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _vars = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageOverlay = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e18z9yhu0'
	})('text-align:center;box-sizing:border-box;div{height:190px;border-radius:4px;overflow:hidden;position:relative;background-image:url("', function (props) {
	  return props.backgroundImage ? props.backgroundImage : '';
	}, '");background-size:cover;background-position:center;align-items:center;margin:6px;display:flex;transition:all 0.15s ease-in-out;&:after{content:\'\';position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(224,39,45,0.75);z-index:1;transition:all 0.15s ease-in-out;}}h3{position:relative;z-index:2;padding:20px;margin:0;flex:1;}');
	
	var link = /*#__PURE__*/(0, _reactEmotion.css)('text-decoration:none;color:', _vars.colors.white, ';align-self:center;&:hover{filter:drop-shadow(0px 0px 4px rgba(0,0,0,0.4));transition:all 0.15s ease-in-out;.image{height:196px;margin:0;transition:all 0.15s ease-in-out;&:after{border-radius:4px;background-color:rgba(224,39,45,0.95);transition:all 0.15s ease-in-out;}}}');
	
	var Image = exports.Image = function Image(props) {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: props.to, className: link },
	    _react2.default.createElement(
	      ImageOverlay,
	      { backgroundImage: props.image },
	      _react2.default.createElement(
	        'div',
	        { className: "image" },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.children
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SideBySide = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(25);
	
	var _reactEmotion = __webpack_require__(12);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideBySideStyles = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'es3geep0'
	})('&:not(:last-of-type){margin-bottom:100px;}');
	
	var Grid = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'es3geep1'
	})('max-width:', function (props) {
	  return props.narrow ? 80 : 100;
	}, '%;margin:auto;box-sizing:border-box;display:grid;grid-template-columns:repeat(2,1fr);grid-gap:30px;direction:', function (props) {
	  return props.align === 'right' ? 'rtl' : 'ltr';
	}, ';div{text-align:left;}@media (max-width:768px){grid-template-columns:1fr;max-width:100%;}a{margin-top:10px;}');
	
	var SideBySide = exports.SideBySide = function SideBySide(props) {
	  return _react2.default.createElement(
	    SideBySideStyles,
	    null,
	    _react2.default.createElement(
	      Grid,
	      { align: props.align, narrow: props.narrow },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', {
	          className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('background-image:url(\'', props.image, '\');background-repeat:no-repeat;background-position:center;background-size:', props.contain ? 'contain' : 'cover', ';border-radius:4px;overflow:hidden;padding-top:67%;')
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('direction:ltr;') },
	        _react2.default.createElement(
	          'h2',
	          null,
	          props.heading
	        ),
	        props.copy && _react2.default.createElement(
	          'p',
	          null,
	          props.copy
	        ),
	        props.html && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.html } }),
	        props.to && _react2.default.createElement(
	          _button.Button,
	          { to: props.to },
	          props.text
	        ),
	        props.downloads && props.downloads.map(function (download, i) {
	          return _react2.default.createElement(
	            _button.Button,
	            { external: true, to: download.file, key: i },
	            download.text || 'Download PDF'
	          );
	        })
	      )
	    )
	  );
	};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TextCard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(25);
	
	var _reactEmotion = __webpack_require__(12);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _vars = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1h1da080'
	})('text-align:center;p.large{color:', _vars.colors.primary, ';}p:last-of-type{margin-bottom:40px;}');
	
	var TextCard = exports.TextCard = function TextCard(props) {
	  return _react2.default.createElement(
	    Card,
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'large' },
	      props.heading
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.copy
	    ),
	    props.href && _react2.default.createElement(_button.Button, { href: props.href })
	  );
	};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(116);
	
	var _constrain = __webpack_require__(28);
	
	var _button = __webpack_require__(25);
	
	var _TextCard = __webpack_require__(303);
	
	var _reactEmotion = __webpack_require__(12);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _vars = __webpack_require__(21);
	
	var _Image = __webpack_require__(302);
	
	var _SideBySide = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g0'
	})('box-sizing:border-box;display:grid;grid-template-columns:repeat(', function (props) {
	  return props.columns ? props.columns : 3;
	}, ',1fr);grid-gap:', function (props) {
	  return props.gap ? props.gap : 60;
	}, 'px;z-index:1;position:relative;@media (max-width:768px){grid-template-columns:repeat(', function (props) {
	  return props.mobile ? props.mobile : 2;
	}, ',1fr);}');
	
	var arrow = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;z-index:1;background-color:#f5f5f5;img{width:100%;z-index:1;}');
	
	var IndexPage = function IndexPage(_ref) {
	  var products = _ref.data.products.group;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Just In Time',
	      meta: [{
	        name: 'description',
	        content: 'We serve the entire United States with same-day shipment of Digester Blow Valves, Liquor Valves, Check Valves and other Digester Valves!"'
	      }]
	    }),
	    _react2.default.createElement(_Hero.Hero, {
	      image: "/images/homepageValve.png",
	      heading: "Just In Time.",
	      content: "We serve the entire United States with same-day shipment of Digester Blow Valves, Liquor Valves, Check Valves and other Digester Valves!",
	      to: "/contact",
	      text: "Request A Quote",
	      imageUrl: "/liquor-valves"
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('background-color:#f5f5f5;padding-bottom:40px;') },
	      _react2.default.createElement(
	        'div',
	        { className: arrow },
	        _react2.default.createElement('img', { src: '/images/heroArrow.svg', alt: '' })
	      ),
	      _react2.default.createElement(
	        _constrain.Constrain,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('max-width:70%;margin:0 auto 60px;text-align:center;@media (max-width:768px){max-width:100%;}') },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'We\'re Ready When You Are'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We know valve failures rarely happen at convinient times, which is why we pride ourselves on having the best customer service whether it\u2019s 2pm or 2am. '
	          )
	        ),
	        _react2.default.createElement(
	          Grid,
	          { columns: 3, mobile: 1 },
	          _react2.default.createElement(_TextCard.TextCard, {
	            heading: 'Same Day Shipping',
	            copy: 'We offer same day shipping to the entire United States. Call us today to see how quickly we can get you what you need!'
	          }),
	          _react2.default.createElement(_TextCard.TextCard, {
	            heading: '24 Hr Response',
	            copy: 'Whether it\u2019s 2pm or 2am, AVI specializes in getting you the right valve at the right time. Call us today to see how quickly we can get you what you need!'
	          }),
	          _react2.default.createElement(_TextCard.TextCard, {
	            heading: 'Valves In-Stock',
	            copy: 'We know valve failures rarely happen at convenient times, which is why we stock many of the valves you need in our warehouse to better serve you!'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('max-width:70%;margin:40px auto 60px;text-align:center;@media (max-width:768px){max-width:100%;}') },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Digester Valves'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We are NAF\u2019s Exclusive Master Distributor for the entire United States. Give us a call to see how we can help meet your needs!'
	          )
	        ),
	        _react2.default.createElement(
	          Grid,
	          { columns: 4, mobile: 1, gap: 10 },
	          products.map(function (product, i) {
	            if (product.edges[0].node.frontmatter.category === 'Control Valves') {
	              return _react2.default.createElement(
	                _Image.Image,
	                {
	                  key: i,
	                  to: product.edges[0].node.frontmatter.path,
	                  image: product.edges[0].node.frontmatter.image
	                },
	                product.edges[0].node.frontmatter.category
	              );
	            }
	          }),
	          products.map(function (product, i) {
	            if (product.edges[0].node.frontmatter.category !== 'Control Valves') {
	              return _react2.default.createElement(
	                _Image.Image,
	                {
	                  key: i,
	                  to: product.edges[0].node.frontmatter.path,
	                  image: product.edges[0].node.frontmatter.image
	                },
	                product.edges[0].node.frontmatter.category
	              );
	            }
	          })
	        ),
	        _react2.default.createElement('hr', { className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)('max-width:25vw;margin:80px auto;') }),
	        _react2.default.createElement(_SideBySide.SideBySide, {
	          image: "/images/avi_team.jpg",
	          align: "left",
	          heading: "About AVI",
	          copy: "Advanced Valve and Instrument, Inc. began operations in mid-1994 with a focus on being a short turnaround supplier of automated quarter turn valves. Since our beginning, that vision has expanded to include instrumentation and valve application seminars, classes, and valve application consulting.",
	          to: "/about",
	          text: "",
	          narrow: true
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4892412cc37cf7bc369d.js